import Payment from '../../components /ProductPage/payment'

const PaymentPage = () => {
  return (
    <div>
      <Payment />
    </div>
  )
}

export default PaymentPage
